import { useConfigBoolean } from 'src/contexts/statsig-config-provider';

const WORKSPACE_READONLY_MODE = 'workspace-readonly-mode';

/**
 * Hook to check if the workspace is in readonly mode.
 * When in readonly mode, UI actions to add, remove, or modify should be disabled.
 *
 * @returns {boolean} true if workspace is in readonly mode, false otherwise
 */
export const useWorkspaceReadonlyMode = (): boolean => {
  return useConfigBoolean(WORKSPACE_READONLY_MODE, false);
};
